enum BonusCategory {
    Active = 'Active',
    AvailableToWager = 'AvailableToWager',
    UnavailableToWager = 'UnavailableToWager',
    CriteriaRequired = 'CriteriaRequired',
    History = 'History',
}

export default BonusCategory;
